export const defaultGameInfo = {
  user_name: '',
  user_id: '',
  currency: 'USD',
  balance: '',
  toFix: 2,
  maxBet: '',
  minBet: '',
  serverSeedSHA256: '',
  clientSeed: '',
  nonce: 0,
  next_server_seed_SHA256: '',
}

export const defaultConfig = {
  stake: '0',
  rollAmount: '0',
  onWin: true,
  onWinPercent: '0',
  onLoss: true,
  onLossPercent: '0',
  stopOnLoss: '0',
  stopOnWin: '0',
  maxStake: '0',
  rollNumber: '50',
  rollUnder: '0',
  isSaved: '0',
}
export const defaultBetInfo = {
  betInfoBalance: '',
  bet: '0',
  bet_id: '',
  currency: '',
  result: 0,
  profit: 0,
  roll: 5000,
  up: 0,
  user_id: '',
  user_name: '',
}
export const defaultAutoConfigs = {
  stake: '0',
  rollAmount: '0',
  onWin: true,
  onWinPercent: '100',
  onLoss: true,
  onLossPercent: '100',
  stopOnLoss: '0',
  stopOnWin: '0',
  maxStake: '',
}

export const defaultSeeds = {
  client_seed: '',
  server_seed_SHA256: '',
  next_server_seed_SHA256: '',
  nonce: 0,
  old_client_seed: '',
  old_server_seed: '',
  old_server_seed_SHA256: '',
  old_nonce: 0,
}

export const defaultBetReply = {
  user_id: '',
  user_name: '',
  bet_id: 0,
  round_id: '',
  betAmount: 0,
  winAmount: 0,
  currency: '',
  winCoef: 0,
  client_seed: '',
  server_seed: '',
  server_seed_SHA256: '',
  nonce: 0,
  date: '',
  roll: '',
  up: 0,
  number: 0,
}

export const defaultAudio = {
  sound: '50',
  music: '50',
  isMusicOff: false,
  isSoundOff: true,
}
